import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { UiControlValueAccessorDirective } from '../../basics/ui-control-value-accessor';
import { BoschUiInputTextComponent } from '../bosch-ui-input-text/bosch-ui-input-text.component';
import { BoschUiInputDatetimeComponent } from '../bosch-ui-input-datetime/bosch-ui-input-datetime.component';
import { takeUntil } from 'rxjs';
import { provideCustomCVA } from '../../basics/ui-custom-cva.provider';

@Component({
  selector: 'bosch-ui-demo-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, BoschUiInputTextComponent, BoschUiInputDatetimeComponent],
  templateUrl: './demo-form.component.html',
  styleUrls: ['./demo-form.component.scss'],
  providers: [provideCustomCVA(DemoFormComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoFormComponent extends UiControlValueAccessorDirective<unknown> implements OnInit {
  form = new FormGroup({
    firstName: new FormControl(null, [Validators.required]),
    lastName: new FormControl(null, [Validators.required]),
    date: new FormControl(null, [Validators.required]),
    address: new FormControl(null),
  });

  override ngOnInit(): void {
    super.ngOnInit();

    this.form.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value: unknown) => {
      this.onChange(value);
    });
  }

  override validate(control: AbstractControl): ValidationErrors | null {
    if (!this.parentControl) {
      this.parentControl = control;
    }

    if (this.parentControl) {
      super.validate(this.parentControl);
    }

    return this.form.valid ? null : { formInvalid: true };
  }
}
